export default "__VITE_ASSET__CI5Gg72a__";